import defaults from './uiConfig.defaults'

const state = {
  config: {}, // filled by load/set
}

const mutations = {
  SET_CONFIG(state, config) {
    state.config = config || {}
  },
  RESET_CONFIG(state) {
    state.config = {}
  },
}

const actions = {
  setUIConfig({ commit }, config) {
    commit('SET_CONFIG', config)
  },
  async loadUIConfig({ commit }, apiConfigPromise) {
    try {
      const remote = await apiConfigPromise
      commit('SET_CONFIG', remote.data || {})
    } catch (e) {
      console.log(e)
      commit('RESET_CONFIG')
    }
  },
  resetUIConfig({ commit }) {
    commit('RESET_CONFIG')
  },
}

const getters = {
  //Returns the "merged" config: all defaults + custom overrides (basic deep merge, pure JS works)
  fullUIConfig: state => {
    return { ...defaults, ...state.config }
  },
  //getters for all the field from API
  ...Object.keys(defaults).reduce((acc, key) => {
    acc[key] = state =>
      state.config[key] !== undefined ? state.config[key] : defaults[key]
    return acc
  }, {}),
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
